<script setup lang="ts">
const { defineOgMeta } = useSeoAttributes()
const {
  public: { baseUrl },
} = useRuntimeConfig()

const { fetchCompany, company } = useCompany()

const { pending, data } = await useAsyncData('company', async () => fetchCompany())

if (data.value) {
  useHead(() => ({
    title: data.value!.page_meta.title,
    meta: defineOgMeta(data.value!.page_meta),
    link: [{ rel: 'canonical', href: `${baseUrl}/company` }],
  }))
}
</script>

<template>
  <Loader :pending="pending">
    <main class="flex w-full flex-col overflow-hidden">
      <AboutUsHero />
      <AboutUsStats />

      <Container v-if="company.content" class="screen-content">
        <RichText
          :raw="company.content"
          class="prose-h2:text-base prose-h2:!text-gray-600 prose-h2:!font-medium content-company mx-auto max-w-screen-sm !py-8 leading-snug !text-gray-600"
        />
      </Container>
      <AboutUsQuoteCard />
      <AboutUsTeam />
      <Container class="h-32" />
    </main>
  </Loader>
</template>
